import { medicareApiClient } from 'clients/medicareApiClient'
import { cookieInterfaces } from './cookies'

const oifCookieInterfaces = [
  cookieInterfaces.oifOraOsfsSession,
  cookieInterfaces.oifNgdOifJSessionId,
  cookieInterfaces.oifJSession
]

/**
 * @returns true if a cookie associated with OIF exists in the browser
 */
export const oifAuthCookiesExist = () => (
  oifCookieInterfaces.some(
    (cookieInterface) => cookieInterface.isSet()
  )
)

// Using standard function so we can spy on this in tests
/**
 * If OIF auth cookies exist, calls the backend oif logout endpoint
 */
export async function logoutFromOifIfLoggedIn () {
  if (oifAuthCookiesExist()) {
    medicareApiClient.beacons.oifLogout()
  }
}
